// extracted by mini-css-extract-plugin
export default {"banner":"cotactus_banner__WoF7E"};